module.exports = __webpack_public_path__ + "img/UNIBET.43fa7a6c.svg";